import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CompetitionTypeSelection.css';
import {
  UsersIcon,
  UserIcon,
  PirateIcon,
  WarningIcon,
  InfoIcon
} from '../components/FencingIcons';

const CompetitionTypeSelection = () => {
  const navigate = useNavigate();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationType, setConfirmationType] = useState(null);

  // Funzione per cancellare tutti i dati delle competizioni
  const clearAllCompetitionData = () => {
    console.log('Avvio pulizia dati competizione...');

    // Elenco di tutte le chiavi nel localStorage che contengono dati di competizione
    const keysToRemove = [
      // Dati individuali
      'individual_numPools', 'individual_schema', 'individual_manual_pools',
      'individual_sbarramento', 'individual_stoccateGirone', 'individual_stoccateElimDiretta',
      'individual_teams', 'individual_matches', 'individual_bracket',

      // Dati squadre
      'teams_data', 'team_config', 'team_matches', 'team_bracket',
      'team_round_robin', 'team_elimination', 'team_final_ranking',

      // Dati competizione mista
      'mixed_config', 'mixed_teams', 'mixed_matches', 'mixed_bracket',
      'mixed_results', 'mixed_ranking',

      // Dati comuni
      'competitionType', 'competition_name', 'competition_date',
      'teams', 'matches', 'bracket', 'match_results', 'current_round',
      'round_robin_results', 'elimination_results', 'final_ranking',
      'pool_results', 'direct_elimination', 'ranking', 'settings',
      'last_competition_type', 'tournament_state', 'current_stage',

      // Registry degli ID stabili
      '_stable_id_registry'
    ];

    // Contatore per tenere traccia delle chiavi rimosse
    let removedCount = 0;

    // Rimuovi tutte le chiavi
    keysToRemove.forEach(key => {
      if (localStorage.getItem(key) !== null) {
        localStorage.removeItem(key);
        removedCount++;
        console.log(`Rimossa chiave: ${key}`);
      }
    });

    console.log(`Pulizia completata. Rimosse ${removedCount} chiavi dal localStorage.`);

    // Forza un refresh per assicurarsi che tutti i componenti ricevano lo stato aggiornato
    window.dispatchEvent(new Event('storage'));
  };

  // Gestori per ogni tipo di competizione
  const handleCompetitionSelection = (type) => {
    const existingData = [
      'teams', 'matches', 'bracket', 'individual_numPools', 'team_config', 'mixed_config'
    ].some(key => localStorage.getItem(key));

    if (existingData) {
      setConfirmationType(type);
      setShowConfirmation(true);
    } else {
      proceedWithCompetition(type);
    }
  };

  const proceedWithCompetition = (type) => {
    clearAllCompetitionData();

    // Imposta il tipo di competizione nel localStorage
    localStorage.setItem('competitionType', type);
    console.log(`Tipo di competizione impostato: ${type}`);

    switch (type) {
      case 'team':
        navigate('/config-squadre');
        break;
      case 'individual':
        navigate('/config-individuale');
        break;
      case 'mixed':
        navigate('/config-miste');
        break;
      default:
        navigate('/');
    }
  };

  return (
    <div className="competition-selection-container">
      {/* Modal di conferma */}
      {showConfirmation && (
        <div className="confirmation-modal">
          <div className="confirmation-content">
            <h2><WarningIcon style={{ color: '#d32f2f', marginRight: 10, fontSize: 28 }} /> Attenzione</h2>
            <p>Esistono già dati di una competizione precedente. Procedendo, tutti i dati verranno cancellati.</p>
            <p>Sei sicuro di voler continuare?</p>
            <div className="confirmation-buttons">
              <button
                className="confirm-btn"
                onClick={() => {
                  proceedWithCompetition(confirmationType);
                  setShowConfirmation(false);
                }}
              >
                Conferma
              </button>
              <button
                className="cancel-btn"
                onClick={() => setShowConfirmation(false)}
              >
                Annulla
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="app-header">
        <h1>123 Scherma!</h1>
        <p className="subtitle">Seleziona la tipologia di competizione da gestire</p>
      </div>

      <div className="competition-options">
        <button
          className="competition-btn"
          onClick={() => handleCompetitionSelection('team')}
        >
          <div className="competition-icon" style={{ backgroundColor: '#388e3c' }}>
            <UsersIcon style={{ fontSize: 40, color: 'white' }} />
          </div>
          <div className="competition-content">
            <strong>Competizione a Squadre</strong>
            <p>Gestione gara a squadre, girone singolo, eliminazione diretta e classifica.</p>
            <div className="features-list">
              <span className="feature-tag">Scegli chi chiude</span>
              <span className="feature-tag">Flessibile</span>
              <span className="feature-tag">Classifica</span>
            </div>
          </div>
        </button>

        <button
          className="competition-btn"
          onClick={() => handleCompetitionSelection('individual')}
        >
          <div className="competition-icon" style={{ backgroundColor: '#d32f2f' }}>
            <UserIcon style={{ fontSize: 40, color: 'white' }} />
          </div>
          <div className="competition-content">
            <strong>Competizione Individuale</strong>
            <p>Organizza tornei individuali completi con gironi multipli.</p>
            <div className="features-list">
              <span className="feature-tag">Gironi multipli</span>
              <span className="feature-tag">Eliminazione diretta</span>
              <span className="feature-tag">Ranking</span>
            </div>
          </div>
        </button>

        <button
          className="competition-btn"
          onClick={() => handleCompetitionSelection('mixed')}
        >
          <div className="competition-icon" style={{ backgroundColor: '#9c27b0' }}>
            <PirateIcon style={{ fontSize: 40, color: 'white' }} />
          </div>
          <div className="competition-content">
            <strong>Competizione Mista</strong>
            <p>Gara a squadre con due o più categorie impostabili.</p>
            <div className="features-list">
              <span className="feature-tag">Multi-categoria</span>
              <span className="feature-tag">Accoppiamenti ottimizzati</span>
              <span className="feature-tag">Flessibile</span>
            </div>
          </div>
        </button>
      </div>

      <div className="info-section">
        <div className="info-card">
          <h3><InfoIcon style={{ color: '#1976d2', marginRight: 8, fontSize: 24 }} /> Funzionalità comuni</h3>
          <ul>
            <li>Possibilità di aggiornare durante la gara nomi dei partecipanti</li>
            <li>Aggiungere o togliere partecipanti in qualsiasi momento</li>
            <li>Creazione del tabellone delle eliminazioni dirette</li>
            <li>Gestione automatica dei punteggi e delle classifiche</li>
          </ul>
        </div>
      </div>


    </div>
  );
};

export default CompetitionTypeSelection;
